export default __webpack_public_path__ + "static/media/ArrowDown.b2481a6e.svg";